export default __webpack_public_path__ + "static/media/vip-card.3c54d031.svg";